module.exports = __webpack_public_path__ + "static/media/lt-logo.da05a9c6.png";